<template>
    <div>
    </div>
  </template>
  
  <script>
  export default {
    mounted() {
      this.$auth.logout()
        .then(() => {
          this.$router.push('/');
        })
        .catch(error => {
          console.error('Error durante el logout:', error);
        });
    },
  };
  </script>
  